<template>
	<div class="home-container">
		<div class="linear-bg"></div>
		<div class="home-scroll">
			<div class="banner">
				<swiper class="banner_swiper" :options="bannerSwiperOption">
					<swiper-slide v-for="(v,key) in banners" :key="key">
						<van-image class="banner_img" round :src="v.url">
							<template v-slot:loading>
								<van-loading type="circular" />
							</template>
						</van-image>
					</swiper-slide>
				</swiper>
			</div>
			<div class="notice-bar">
				<van-notice-bar class="notice-swipe" left-icon="bullhorn-o" background="#ffffff" color="#f487e0"
					:text="this.notice" />
				<div class="linear-gradient"></div>
			</div>
			<div class="hot-game">
				<div class="hot-title-div">
					<div>
						<span>{{$t('index.同城福利')}}</span>
					</div>
					<div @click="gotoMenu('/pickgirl')">
						<span>{{$t('index.more')}}</span>
						<van-icon name="arrow" color="#979799" />
					</div>
				</div>
				<div class="gameContent">
					<div class="welfare-banner">
						<img src="../../assets/sfks-2.png" alt="" @click="toLottery('game1', 10)">
						<img src="../../assets/sfks2-2.png" alt="" @click="toLottery(5, 11)">
					</div>
					<div class="hot-title-div welfare-list-title">
						<div>
							<span>直播间</span>
						</div>
					</div>
					<div class="live-room-list" v-if="liveRoomItem">
						<div class="live-room-card" @click="toLive(liveRoomItem.id)">
							<img
								v-if="liveBanner"
								class="live-room-img"
								:src="liveBanner"
							>
							<div class="live-room-info">
								<span>{{liveTitle}}</span>
								<van-icon name="play-circle-o" color="#fff" />
							</div>
						</div>
					</div>
					<div class="hot-title-div welfare-list-title">
						<div>
							<span>选妃列表</span>
						</div>
					</div>
					<van-list
						v-model="xuanfeiLoading"
						:finished="xuanfeiFinished"
						:immediate-check="false"
						finished-text="沒有更多了"
						@load="onXuanfeiLoad"
					>
						<div class="welfare-list">
							<div
								class="welfare-card"
								v-for="item in xuanfeilist"
								:key="item.id"
								@click="toProfile(item.id)"
							>
								<img
									v-if="getXuanfeiImage(item)"
									class="welfare-img"
									:src="getXuanfeiImage(item)"
									@error="onXuanfeiImageError(item)"
								>
								<div class="welfare-info">
									<div class="welfare-name">{{item.xuanfei_name}}</div>
									<div class="welfare-meta" v-if="item.address">
										<van-icon name="location-o" color="#ffb54a" />
										<span>{{item.address}}</span>
									</div>
									<div class="welfare-meta" v-if="item.money">
										<van-icon name="shield-o" color="#63d7a3" />
										<span>已繳納{{item.money}}元保證金</span>
									</div>
									<div class="welfare-sign" v-if="item.sign">{{item.sign}}</div>
									<div class="welfare-tags" v-if="formatTags(item.label).length">
										<span
											v-for="(tag, index) in formatTags(item.label)"
											:key="index"
											:style="tagStyle(index)"
										>{{ tag }}</span>
									</div>
								</div>
							</div>
						</div>
					</van-list>
					<div class="welfare-loading" v-if="xuanfeiFirstLoading">
						<van-loading type="spinner" color="#ff4ea3" />
					</div>
					<van-empty v-else-if="!xuanfeilist.length" description="暂无资料" />
				</div>
			</div>
			<van-pull-refresh pulling-text="새로고침 성공" 
			loosing-text="페이지 새로 고침" 
			loading-text="새로고침 성공" 
			success-text="새로고침 성공" v-model="isLoading" @refresh="onRefresh">
				<div class="hot-recommend" v-show="false">
					<div class="hot-title-div">
						<div>
							<span>{{$t('index.hot')}}</span>
						</div>
						<div v-show="false">
							<span @click="gotoMenu('/Video')">{{$t('index.more')}}</span>
							<van-icon name="arrow" color="#979799" />
						</div>
					</div>
					<div class="movie_list_0">
						<swiper class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v,key) in movielist_0" :key="key">
								<van-image class="movie_cover" @click="toPlayVideo(v.id)" round :src="v.cover">
									<template v-slot:loading>
										<van-loading type="circular" />
									</template>
								</van-image>
								<img class="hot" v-if="key === 0" src="/img/home/no1.png">
								<img class="hot" v-if="key === 1" src="/img/home/no2.png">
								<img class="hot" v-if="key === 2" src="/img/home/no3.png">
								<div class="movie-list-item-bottom">
									<div class="movie-time-div">
										<span>{{v.vod_name}}</span>
										<div class="van-count-down">{{v.time}}</div>
									</div>
								</div>
							</swiper-slide>
						</swiper>
					</div>
					<div class="hot-title-div">
						<div>
							<span>{{$t('index.more')}}</span>
						</div>
						<div @click="gotoMenu('/Video')">
							<span>{{$t('index.recmonmand')}}</span>
							<van-icon name="arrow" size="25" color="#979799" />
						</div>
					</div>
					<div class="movie_list_1">
						<div class="movie-list-item" v-for="(v,key) in movielist_1" :key="key"
							@click="toPlayVideo(v.id)">
							<van-image class="cover_img" round :src="v.cover">
								<template v-slot:loading>
									<van-loading type="circular" />
								</template>
							</van-image>
							<div class="movie-list-item-bottom">
								<div class="movie-time-div">
									<span>{{v.vod_name}}</span>
									<span>{{$t('video.play')}}:{{v.count}}</span>
								</div>
							</div>
						</div>
						<div class="hot-recommend-more" @click="gotoMenu('/Video')">{{$t('index.more')}}</div>
					</div>
				</div>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				notice: this.$t("index.loading"),
				banners: [{}],
				basicData: [],
				gameitem: [{}, {}, {}, {}],
				xuanfeilist: [],
				xuanfeiPage: 0,
				xuanfeiCount: 0,
				xuanfeiLoading: false,
				xuanfeiFinished: false,
				xuanfeiFirstLoading: true,
				movielist_0: [{}, {}, {}, {}],
				movielist_1: [{}, {}, {}, {}, {}, {}, {}, {}],
				isLoading: false,
				movielistSwiperOption: {
					slidesPerView: 'auto',
					spaceBetween: 0,
					slidesPerGroup: 1,
				},
				bannerSwiperOption: {
					effect: 'coverflow',
					grabCursor: true,
					centeredSlides: true,
					slidesPerView: 'auto',
					speed: 800,
					autoplay: true,
					coverflowEffect: {
						rotate: 50,
						stretch: 10,
						depth: 100,
						modifier: 1,
						slideShadows: true
					}
				}
			};
		},
		computed: {
			liveRoomItem() {
				return this.xuanfeilist[0] || null;
			},
			liveBanner() {
				return this.basicData.live_banner || (this.liveRoomItem && this.getXuanfeiImage(this.liveRoomItem));
			},
			liveTitle() {
				return this.basicData.live_title || (this.liveRoomItem && this.liveRoomItem.xuanfei_name) || '直播间';
			}
		},
		methods: {
			gotoMenu(router) {
				this.$router.replace(router)
			},
			toLottery(key, id) {
				if (!localStorage.getItem('token')) {
					this.$router.push({
						path: '/Login'
					})
				} else {
					this.$router.push({
						path: '/Lottery?key=' + key + "&id=" + id
					})
				}

			},
			toProfile(id) {
				this.$router.push({
					name: 'profile',
					query: { id }
				})
			},
			getXuanfeiImage(item) {
				return item.show_img || item.img_url2 || item.img_url;
			},
			onXuanfeiImageError(item) {
				if (item.show_img === item.img_url || !item.img_url) {
					return;
				}
				this.$set(item, 'show_img', item.img_url);
			},
			formatTags(tags) {
				if (Array.isArray(tags)) {
					return tags.filter(Boolean);
				}
				if (!tags) {
					return [];
				}
				if (typeof tags === 'string') {
					try {
						const parsedTags = JSON.parse(tags);
						if (Array.isArray(parsedTags)) {
							return parsedTags.filter(Boolean);
						}
					} catch (e) {
						return this.splitTags(tags);
					}
					return this.splitTags(tags);
				}
				return [];
			},
			splitTags(tags) {
				return tags
					.replace(/\uFF0C|\u3001|\u3002/g, ',')
					.split(/[,.|/\s]+/)
					.map(tag => tag.trim())
					.filter(Boolean);
			},
			tagStyle(index) {
				const colors = ['#e9476a', '#2dabd2', '#dea52b', '#8b63d9', '#24b47e', '#f06f3c'];
				return {
					backgroundColor: colors[index % colors.length]
				};
			},
			onXuanfeiLoad() {
				this.getXuanfeiList();
			},
			toLive(id) {
				this.$router.push({
					path: '/Live',
					query: { id }
				});
			},
			toPlayVideo(id) {
				if (!localStorage.getItem('token')) {
					this.$router.push({
						path: '/Login'
					})
				} else {
					this.$router.push({
						path: '/PlayVideo?id=' + id
					})
				}
			},
			onRefresh() {
				setTimeout(() => {
					this.getBasicConfig();
					this.isLoading = false;
					this.$toast("새로고침 성공");
				}, 500);
			},
			getBasicConfig() {
				this.$http({
					method: 'get',
					url: 'sys_config'
				}).then(res => {
					this.basicData = res.data;
					console.log('base data', res.data);
					// console.info(res)
					this.getNotice(this.basicData); //获取公告
					this.getBanner(this.basicData); //获取banner
					this.getGameItem(); //获取首页游戏列表
					this.resetXuanfeiList();
					this.getXuanfeiList();
					this.getMovieList_0(this.basicData); //获取首���视频0
					this.getMovieList_1(this.basicData); //获取首页视频1
				})

			},
			getNotice(data) {
				this.notice = data.notice;
			},
			getGameItem() {
				this.$http({
					method: 'get',
					url: 'lottery_hot'
				}).then(res => {
					this.gameitem = res.data
				})
			},
			resetXuanfeiList() {
				this.xuanfeilist = [];
				this.xuanfeiPage = 0;
				this.xuanfeiCount = 0;
				this.xuanfeiLoading = false;
				this.xuanfeiFinished = false;
				this.xuanfeiFirstLoading = true;
			},
			getXuanfeiList() {
				if (this.xuanfeiFinished) {
					return;
				}
				this.$http({
					method: 'get',
					url: 'xuanfeilist',
					data: { page: this.xuanfeiPage }
				}).then(res => {
					const data = res.data || {};
					const list = Array.isArray(data) ? data : (data.data || []);
					const oldLength = this.xuanfeilist.length;
					const oldIds = this.xuanfeilist.map(item => item.id);
					const newList = list.filter(item => oldIds.indexOf(item.id) === -1);

					this.xuanfeilist = this.xuanfeilist.concat(newList);
					this.xuanfeiCount = data.count || this.xuanfeiCount;
					this.xuanfeiPage++;
					this.xuanfeiLoading = false;
					this.xuanfeiFirstLoading = false;

					if (!list.length || this.xuanfeilist.length === oldLength) {
						this.xuanfeiFinished = true;
					}
					if (this.xuanfeiCount && this.xuanfeilist.length >= this.xuanfeiCount) {
						this.xuanfeiFinished = true;
					}
				}).catch(() => {
					this.xuanfeiLoading = false;
					this.xuanfeiFirstLoading = false;
					this.xuanfeiFinished = true;
				})
			},
			getMovieList_0(data) {
				this.movielist_0 = data.movielist_0
			},
			getMovieList_1(data) {
				this.movielist_1 = data.movielist_1
			},
			getBanner(data) {
				this.banners = data.banners;
			}
		},
		mounted() {

		},
		created() {
			this.getBasicConfig();
		}
	}
</script>

<style lang='less' scoped>
	@notice-bar-size: 30px;
	@movie-list-item-bottom-size: 25px;
	.gameContent {
		padding: 10px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.welfare-banner {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 12px;
	}

	.welfare-banner img {
		width: 49%;
		border-radius: 10px;
	}

	.welfare-list-title {
		width: 100%;
		margin: 0 0 8px;
		padding: 0;
		box-sizing: border-box;
		justify-content: flex-start;
	}

	.welfare-list-title>div:first-child {
		width: auto;
		margin-left: -15px;
	}

	.live-room-list {
		width: 100%;
		margin-bottom: 12px;
	}

	.live-room-card {
		position: relative;
		width: 100%;
		height: 360px;
		border-radius: 8px;
		background: #4f3460;
		overflow: hidden;
	}

	.live-room-img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
		background: #3b2b4f;
	}

	.live-room-badge {
		position: absolute;
		top: 8px;
		left: 8px;
		padding: 4px 10px;
		border-radius: 999px;
		background: #ff4ea3;
		color: #fff;
		font-size: 24px;
		font-weight: 600;
	}

	.live-room-info {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;
		padding: 10px;
		background: rgba(0, 0, 0, .45);
		color: #fff;
		font-size: 28px;
	}

	.live-room-info span {
		min-width: 0;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	::v-deep .gameContent .van-list {
		width: 100%;
	}

	.welfare-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.welfare-card {
		width: calc(50% - 6px);
		margin-bottom: 12px;
		border-radius: 8px;
		background: #4f3460;
		overflow: hidden;
	}

	.welfare-img {
		display: block;
		width: 100%;
		height: 240px;
		object-fit: cover;
		background: #3b2b4f;
	}

	.welfare-info {
		padding: 10px;
		color: #fff;
	}

	.welfare-name {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		font-size: 28px;
		font-weight: 600;
	}

	.welfare-meta {
		display: flex;
		align-items: center;
		gap: 4px;
		margin-top: 6px;
		color: #eee7f7;
		font-size: 20px;
		line-height: 1.3;
	}

	.welfare-meta span {
		min-width: 0;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.welfare-sign {
		margin-top: 6px;
		color: #f4edf8;
		font-size: 20px;
		line-height: 1.35;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.welfare-tags {
		display: flex;
		flex-wrap: wrap;
		gap: 4px;
		margin-top: 8px;
	}

	.welfare-tags span {
		max-width: 100%;
		padding: 4px 8px;
		border-radius: 999px;
		color: #fff;
		font-size: 18px;
		font-weight: 600;
		line-height: 1.2;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.welfare-loading {
		width: 100%;
		min-height: 260px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.linear-bg {
		height: 200px;
		// background: linear-gradient(270deg, #988fba, #f487e0);
		background-image: url('/img/homebg.png');
	}

	.home-container {
		position: absolute !important;
		top: 0;
		left: 0;
		right: 0;
		background-color: #29243D;
	}

	.linear-gradient {
		width: 100%;
		height: 2px;
		background: linear-gradient(to right, rgba(76, 32, 111, 0), rgb(50, 55, 149), rgba(76, 32, 111, 0));	}

	::v-deep .van-notice-bar__left-icon,
	.van-notice-bar__right-icon {
		min-width: 40px;
	}

	.notice-swipe {
		background-color: #342f47 !important;
		border-radius: 0.5rem;
		// width: calc(100% - 50px);
		height: 85px;
		font-size: @notice-bar-size;
	}
	.notice-bar {
		margin: 1rem;
	}

	::v-deep .van-icon-bullhorn-o::before {
		transform: scale(2.5);
	}

	.banner {
		width: 100%;
		margin-top: -23%;
	}

	.banner_swiper {
		height: 100%;
		width: 100%;

		.swiper-slide {
			border-radius: 10px;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 620px;
			height: 300px;
			text-align: center;
			font-weight: bold;
			font-size: 20px;
			background-color: #ffffff;
			background-position: center;
			background-size: cover;
			color: #ffffff;
		}
	}

	::v-deep .swiper-container-3d .swiper-slide-shadow-left {
		background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
	}

	::v-deep .swiper-container-3d .swiper-slide-shadow-right {
		background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
	}

	.banner_img {
		border-radius: 10px;
		width: 100%;
		height: 100%;
	}

	.hot-game {
		width: 100%;
		height: 100%;
	}

	.hot-title-div {
		width: calc(100% - 50px);
		margin: 0 auto;
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.hot-title-div>div:first-child {
		width: 430px;
	}

	.hot-title-div div {
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.hot-title-div>div:nth-child(2) span {
		font-size: 20px;
		color: #979799;
	}

	.hot-title-div>div:first-child span {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-size: 10px;
		font-weight: 700;
		// color: #000;
	}

	.hot-title-div>div:first-child span {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-size: 28px;
		font-weight: 700;
		// color: #000;
	}

	.hot-title-div>div:nth-child(2) span {
		font-size: 25px;
		// color: #979799;
	}

	.hot-title-div>div:first-child span:before {
		content: "";
		display: block;
		width: 5px;
		height: 30px;
		background-color: #f487e0;
		border-radius: 1px;
		margin-right: 5px;
	}

	.hot-game .hot-items-div {
		margin-top: -3px;
	}

	.hot-game .hot-items-div span {
		margin-top: 10px;
		font-size: 28px;
		// color: #000;
	}

	.hot-recommend {
		width: 100%;
		flex: 1;
		background-color: #29243D;
	}

	.movie_swiper {
		.swiper-slide {
			width: 80%;
		}
	}

	.movie_list_0 {
		width: calc(100% - 50px);
		margin: 0 auto;
	}

	.movie_cover {
		border-radius: 10px;
		width: 550px;
		height: 330px
	}

	.movie_list_0 .movie-list-item-bottom {
		position: relative;
		width: 550px;
		bottom: 43px;
	}

	.movie_list_0 .movie-list-item-bottom .movie-time-div {
		background-color: rgba(0, 0, 0, .4);
	}

	.movie_list_0 .movie-list-item-bottom>div {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.movie_list_0 .movie-list-item-bottom .movie-time-div .van-count-down {
		font-size: 28px;
		color: #fff;
	}

	.movie_list_0 .movie-time-div {
		color: #fff;
		border-radius: 0 0 10px 10px;
	}

	.movie_list_0 .movie_swiper .hot {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 80px;
	}

	.movie_list_0 span {
		font-size: 30px;
	}

	.movie_list_1 {
		display: flex;
		width: calc(100% - 50px);
		margin: 0 auto;
		align-items: flex-start;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.movie_list_1 .movie-list-item .cover_img {
		border-radius: 10px;
		width: 335px;
		height: 290px;
	}

	.home-scroll {
		padding-bottom: 110px;
	}

	.movie_list_1 .movie-list-item {
		margin-bottom: -10px;
	}

	.movie_list_1 .movie-list-item-bottom {
		position: relative;
		width: 335px;
		bottom: 42px;

	}

	.movie_list_1 .movie-list-item:nth-child(odd) {
		margin-right: 25px;
	}

	.movie_list_1 .movie-list-item-bottom .movie-time-div {
		background-color: rgba(0, 0, 0, .4);
	}

	.movie_list_1 .movie-list-item-bottom>div {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.movie_list_1 .movie-list-item-bottom .movie-time-div .van-count-down {
		color: #fff;
	}

	.movie_list_1 .movie-time-div {
		color: #fff;
		border-radius: 0 0 10px 10px;
		height: 35px;
	}

	.movie_list_1 .movie_swiper .hot {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 5px;
	}

	.movie_list_1 .movie-list-item .movie-time-div span:first-child {
		overflow: hidden;
		white-space: nowrap;
		width: 180px;
		padding-left: 8px;
		font-size: 25px;
	}

	.movie_list_1 .movie-list-item .movie-time-div span:last-child {
		overflow: hidden;
		white-space: nowrap;
		width: 0px;
		padding-right: 110px;
		font-size: 22px;
	}

	.movie_list_0 .movie-time-div span:first-child {
		overflow: hidden;
		white-space: nowrap;
		width: 350px;
		padding-left: 10px;
		font-size: 25px;
	}

	.hot-recommend-more {
		width: 100%;
		padding-bottom: 20px;
		text-align: center;
		color: #979799;
		font-size: 30px;
	}

	.hot-items-div .game_item_img {
		width: 100px;
		height: 100px;
	}

	::v-deep .hot-items-div .game_item_img .van-image__img {
		border-radius: 20px;
	}

	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		// color: #000000;
		font-size: 35px;
	}
	span{
    color: #fff;
}
</style>
